export default __webpack_public_path__ + "static/media/NO.796c658a.png";